(() => {
  if (window.__strictInStockFilterInitialised) {
    return;
  }

  window.__strictInStockFilterInitialised = true;

  const STRICT_SWITCH_SELECTOR = 'input[name="strict_in_stock"]';
  const CARD_SELECTOR = '.collection__results product-card';
  const IN_STOCK_SELECTOR = '.product-card__inventory variant-inventory .text-success';
  const FACET_LINK_SELECTOR = 'a[is="facet-link"][href]';

  const isEnabled = () => new URLSearchParams(window.location.search).get('strict_in_stock') === '1';

  const syncSwitches = (enabled = isEnabled()) => {
    document.querySelectorAll(STRICT_SWITCH_SELECTOR).forEach((control) => {
      control.checked = enabled;
      control.toggleAttribute('checked', enabled);
    });
  };

  const filterCards = (enabled = isEnabled()) => {
    document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      const hasInStockInformation = card.querySelector(IN_STOCK_SELECTOR) !== null;
      card.hidden = enabled && !hasInStockInformation;
    });
  };

  const syncFacetLinks = (enabled = isEnabled()) => {
    document.querySelectorAll(FACET_LINK_SELECTOR).forEach((link) => {
      const url = new URL(link.href, window.location.origin);

      url.searchParams.delete('filter.v.availability');

      if (enabled) {
        url.searchParams.set('strict_in_stock', '1');
      } else {
        url.searchParams.delete('strict_in_stock');
      }

      const nextHref = `${url.pathname}${url.search}${url.hash}`;

      if (link.getAttribute('href') !== nextHref) {
        link.setAttribute('href', nextHref);
      }
    });
  };

  const moveSwitchesToTop = () => {
    document.querySelectorAll(STRICT_SWITCH_SELECTOR).forEach((control) => {
      const accordion = control.closest('.accordion');
      const form = control.closest('form.facets-vertical');

      if (!accordion || !form) {
        return;
      }

      const firstAccordion = Array.from(form.children).find((child) => child.classList?.contains('accordion'));

      if (firstAccordion && firstAccordion !== accordion) {
        form.insertBefore(accordion, firstAccordion);
      }
    });
  };

  const refresh = () => {
    const enabled = isEnabled();

    moveSwitchesToTop();
    syncSwitches(enabled);
    filterCards(enabled);
    syncFacetLinks(enabled);
  };

  const setEnabled = (enabled) => {
    const url = new URL(window.location.href);

    url.searchParams.delete('filter.v.availability');

    if (enabled) {
      url.searchParams.set('strict_in_stock', '1');
    } else {
      url.searchParams.delete('strict_in_stock');
    }

    window.history.pushState({}, '', url);
    refresh();
  };

  const bindSwitches = () => {
    document.querySelectorAll(STRICT_SWITCH_SELECTOR).forEach((control) => {
      if (control.dataset.strictInStockBound === 'true') {
        return;
      }

      control.dataset.strictInStockBound = 'true';

      control.addEventListener('input', () => {
        syncSwitches(control.checked);
        filterCards(control.checked);
      }, true);

      control.addEventListener('change', (event) => {
        event.stopImmediatePropagation();
        setEnabled(control.checked);
      }, true);
    });
  };

  let refreshQueued = false;

  const scheduleRefresh = () => {
    if (refreshQueued) {
      return;
    }

    refreshQueued = true;

    window.requestAnimationFrame(() => {
      refreshQueued = false;
      bindSwitches();
      refresh();
    });
  };

  const initialise = () => {
    bindSwitches();
    refresh();

    window.addEventListener('popstate', scheduleRefresh);

    new MutationObserver(scheduleRefresh).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
